import { updateMenu } from '../modules/menu';
import { sliders } from '../modules/sliders';
import { activeSection } from '../modules/waypoints';
import { activeFilters, setupFilters } from '../modules/filtering';
import reframe from 'reframe.js';
import _ from 'lodash'
import 'lazysizes'

export default {
	init() {
		// JavaScript to be fired on all pages
		updateMenu();
		setupScrolling();
		activeSection();
		setupTriggerVideo();
		setupAccordian();
		activeFilters();
		setupFilters();
		embedFrame();
		subnavDragScroll();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		sliders();
		$('.embed-module').each(function(){
			let scripts = $(this).find('script');
			scripts.each(function(){
				let text = $(this).text();
				console.log(text);
				eval(text);
			});
		});
	},
};

/**
 * Sets up the scrolled class
 */
function setupScrolling()
{
	let lastScrollTop = 0;
	const hadleScroll = _.throttle(() => {
		let st = window.pageYOffset || document.documentElement.scrollTop;
		const body = document.body;

		body.classList.toggle('scrolled', st > 120);
		body.classList.toggle('scroll-under', (st > window.innerHeight * 1.75));
		body.classList.toggle('scroll-down', st > lastScrollTop)
		body.classList.toggle('scroll-up', st < lastScrollTop)

		lastScrollTop = st <= 0 ? 0 : st;
	}, 250);

	window.addEventListener('scroll', hadleScroll, false);
}

function setupTriggerVideo()
{
	const videos = document.querySelectorAll('.video-module__inner');

	/**
	 * 
	 * @param {*} e 
	 */
	const hideThumbnail = (e) => {
		const embed = e.currentTarget.querySelector('iframe');
		const embedSrc = embed.getAttribute('src');

		const playSrc = `${embedSrc}&autoplay=1`;

		embed.setAttribute('src', playSrc);

		e.currentTarget.parentNode.parentNode.classList.add('video-active');
	}

	videos.forEach((module) => {
		module.addEventListener('click', hideThumbnail);
	})
}

function setupAccordian()
{
	const accordians = document.querySelectorAll('.show-hide-trigger');

	const slideDown = (elem) => {
		return elem.style.height = `${elem.scrollHeight}px`
	};

	const slideUp = (elem) => {
		return elem.style.height = '0'
	};

	const showHide = (e) => {
		const parent = e.currentTarget.parentNode;
		const body = parent.querySelector('.show-hide__body');

		if (parent.classList.contains('show-hide-active'))
		{
			parent.classList.remove('show-hide-active')
			slideUp(body);
		}
		else
		{
			parent.classList.add('show-hide-active')
			slideDown(body);
		}
	}

	accordians.forEach((accordian) => {
		accordian.addEventListener('click', showHide)
	})
}

function embedFrame()
{
	reframe(document.querySelectorAll('.content iframe'))
}

function subnavDragScroll()
{
	const subNavs = document.querySelectorAll('.sub-nav');

	subNavs.forEach((subNav) => {
		let pos = { top: 0, left: 0, x: 0, y: 0 };

		subNav.style.cursor = 'grab';

		const mouseDownHandler = function (e) {
			subNav.style.cursor = 'grabbing';
			subNav.style.userSelect = 'none';

			pos = {
				left: subNav.scrollLeft,
				top: subNav.scrollTop,
				// Get the current mouse position
				x: e.clientX,
				y: e.clientY,
			};

			document.addEventListener('mousemove', mouseMoveHandler);
			document.addEventListener('mouseup', mouseUpHandler);
		};

		const mouseMoveHandler = function (e) {
			// How far the mouse has been moved
			const dx = e.clientX - pos.x;
			const dy = e.clientY - pos.y;

			// Scroll the element
			subNav.scrollTop = pos.top - dy;
			subNav.scrollLeft = pos.left - dx;
		};

		const mouseUpHandler = function (e) {
			subNav.style.cursor = 'grab';
			subNav.style.removeProperty('user-select');

			document.removeEventListener('mousemove', mouseMoveHandler);
			document.removeEventListener('mouseup', mouseUpHandler);
		};

		// Attach the handler
		subNav.addEventListener('mousedown', mouseDownHandler);
	})
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js